import * as React from 'react';
import * as PropTypes from 'prop-types';
import { Field, reduxForm, FormProps, InjectedFormProps } from 'redux-form';
import { Message, Button } from 'element-react';

import '../common/css/reset.css';
import '../common/css/cmn_layout.css';
import '../common/css/cmn_style.css';
import '../css/login.css';

interface CustomFormProps extends FormProps<InjectedFormProps, {}> {
  auth: any;
  authActions?: any;
  signForm: any;
  dialogActions?: any;
}

class SignForm extends React.Component<CustomFormProps, {}> {
  static propTypes = {
    auth: PropTypes.any.isRequired,
    authActions: PropTypes.any.isRequired,
    signForm: PropTypes.any.isRequired
  };

  private nameInput: any;
  private loading: boolean = false;

  componentDidMount() {
    // nameにフォーカスさせる
    this.nameInput.getRenderedComponent().focus();
  }

  componentWillMount() {
    // 認証状態ならリダイレクトさせる
    if (this.props.auth.isAuthenticated === true) {
      setTimeout(() => window.location.href = '/management_admin_menu', 1000);
    }
  }

  componentDidUpdate() {
    // 認証状態ならリダイレクトさせる
    if (this.props.auth.isAuthenticated === true) {
      setTimeout(() => window.location.href = '/management_admin_menu', 1000);
    }
  }

  handleChangeId(event: any) {
    // DO SOMETHING
  }

  handleChangePassword(event: any) {
    // DO SOMETHING
  }

  handleSubmit() {
    // log in
    if (typeof(this.props.authActions) === 'undefined' || typeof(this.props.signForm) === 'undefined') {
      return;
    }
    this.loading = true;

    // undefinedになってた時に最低から文字にしてcognite側で判断させる
    const username = this.props.signForm.username || '';
    const password = this.props.signForm.password || '';

    this.props.authActions.signIn(
      username,
      password,
      (res: any, message: any) => {
        this.loading = false;
        if (res === false) {
          Message({
            type: 'error',
            duration: 5000,
            message: message.message
          });
        } else {
          Message({
            type: 'success',
            duration: 5000,
            message: 'ログインに成功しました'
          });
        }
      }
    );
  }

  render() {
    return (
      <form>
        <style type="text/css">
        {'.loginForm { width: 100%; }'}
        </style>
        <h2>ログイン</h2>
        <table className="loginForm">
        <tbody>
          <tr>
            <td>
              <Field
                id="accountid"
                name="username"
                component="input"
                type="text"
                placeholder="管理者ID"
                required={true}
                autoFocus={true}
                withRef={true}
                ref={(input: any) => { this.nameInput = input; }}
                onChange={(event) => this.handleChangeId(event)}
              />
            </td>
          </tr>
          <tr>
            <td>
              <Field
                id="password"
                name="password"
                component="input"
                type="password"
                placeholder="Password"
                required={true}
                autoFocus={true}
                withRef={true}
                onChange={(event) => this.handleChangePassword(event)}
              />
            </td>
          </tr>
          <tr>
            <td className="button-wrap">
            <Button type="primary" loading={this.loading} onClick={event => this.handleSubmit()}>
              ログイン
            </Button>
            </td>
          </tr>
          {/*
          <tr>
            <a className="forgot-link" href="/forgot_password">
              パスワードをお忘れの方へ
            </a>
          </tr>
          */}
        </tbody>
        </table>
        {/* <div id="message" className="alert" style={{display: this.state.showAlert ? 'block' : 'none' }} /> */}
      </form>
    );
  }
}

export default reduxForm({
  // configureStoreのformとの連携
  form: 'signForm'
})(SignForm as any);



// WEBPACK FOOTER //
// ./src/components/SignForm.tsx